import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=70e262dc&scoped=true&"
import script from "./PersonalInfo.vue?vue&type=script&lang=js&"
export * from "./PersonalInfo.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfo.vue?vue&type=style&index=0&id=70e262dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e262dc",
  null
  
)

export default component.exports